import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const FanListPage = () =>
  import('@modules/fan/components/fan-list-page.vue');
const FanFormPage = () =>
  import('@modules/fan/components/fan-form-page.vue');
const FanViewPage = () =>
  import('@modules/fan/components/fan-view-page.vue');
const FanImporterPage = () =>
  import('@modules/fan/components/fan-importer-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'fan',
        path: '/fan',
        component: FanListPage,
        meta: {
          auth: true,
          permission: Permissions.values.fanView,
        },
      },
      {
        name: 'fanNew',
        path: '/fan/new',
        component: FanFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.fanCreate,
        },
      },
      {
        name: 'fanImporter',
        path: '/fan/import',
        component: FanImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.fanImport,
        },
      },
      {
        name: 'fanEdit',
        path: '/fan/:id/edit',
        component: FanFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.fanEdit,
        },
        props: true,
      },
      {
        name: 'fanView',
        path: '/fan/:id',
        component: FanViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.fanView,
        },
        props: true,
      },
    ],
  },
];
